
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getCountries",
      resolverType: "query",
      routePath: "/getCountries",
      httpMethod: "POST",
    });
  